import React from 'react';
import Icon from './Icon';
import { IconProps } from './IconProps';

export default function IconCancelled({ className, height, title }: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M16.5 10C16.5 13.5899 13.5899 16.5 10 16.5C8.47531 16.5 7.07322 15.9751 5.96464 15.096L15.096 5.96464C15.9751 7.07322 16.5 8.47531 16.5 10ZM4.90398 14.0354L14.0354 4.90398C12.9268 4.02495 11.5247 3.5 10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 11.5247 4.02495 12.9268 4.90398 14.0354ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58173 14.4183 2 10 2C5.58173 2 2 5.58173 2 10C2 14.4183 5.58173 18 10 18Z</Icon>
  );
}
